/**
* This file was automatically generated by quicktype.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run command(npm run schemabuild) to regenerate this file.
*/
/**
 * 分享类型
 *
 * 默认私信分享
 *
 * 商详私信分享
 *
 * 话题私信分享（v7.5+）
 *
 * 中间页私信分享（v6.88+）
 *
 * 活动页私信分享（v7.5+）
 */
export var ShareToFriendType;
(function (ShareToFriendType) {
    ShareToFriendType["Center"] = "center";
    ShareToFriendType["Event"] = "event";
    ShareToFriendType["General"] = "general";
    ShareToFriendType["GoodsDetail"] = "goodsDetail";
    ShareToFriendType["Topic"] = "topic";
})(ShareToFriendType || (ShareToFriendType = {}));
